// extracted by mini-css-extract-plugin
export default {"NotSubscribed":"NotSubscribed_NotSubscribed__LlezU","text":"NotSubscribed_text__pnrSd","Kindly":"NotSubscribed_Kindly__A9Jaz","Click":"NotSubscribed_Click__54oIX"};